// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2c43c1fc","453":"9ea4ed66","732":"a8b9424c","838":"1ad1e1a6","977":"77429fbe"}[chunkId] + ".chunk.js";
};